'use client'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import useCartServices, { RemoveFromCartProps } from '@lib/CartServices'
import GetImageUrl from '@lib/GetImageUrl'
import useCartStore, { CartItem } from '@store/CartStore'
import { ChevronDown, X } from 'lucide-react'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { FC, useCallback, useMemo } from 'react'
import ProductExtraInfo from './ProductExtraInfo'
// interface Props {
//   name: string
//   price: number
//   discount: number
//   quanity: number
//   imageIds: string[]
//   productId: string
// }

export interface DropDownProps {
  choice: {
    choice: string
    cost: number
  }
  isPrimary: boolean
  title: string
}

export interface CustomizationProps {
  dropDowns?: DropDownProps[]
  textInput?: { title: string; content: string }[]
  stepper?: { title: string; count: number }
}

interface Props extends CartItem {
  onQtyUpdate: (qty: number) => void
}

const CartProductCards: FC<Props> = ({ onQtyUpdate, ...product }) => {
  const cartContext = useCartStore()
  const { data: session } = useSession()
  const { updateCart } = useCartServices()
  const removeFromCart = useCallback(async (cartItem: RemoveFromCartProps) => {
    try {
      const res = await fetch('/api/cart/removeFromCart', {
        method: 'POST',
        body: JSON.stringify(cartItem)
      })

      if (!res.ok) {
        throw new Error('failed to delete the item')
      }
      return res.json()
    } catch (error) {
      throw new Error('failed to remove')
    }
  }, [])

  const handleRemoveFromCart = useCallback(async () => {
    if (session) {
      const prod = cartContext?.cartItems.find((ele) => ele.productId === product.productId)

      if (prod?.cartId) {
        await removeFromCart({
          cartId: String(prod.cartId),
          productId: prod.productId,
          userId: session!.user.userId
        }).then(() => cartContext?.updateCart({ item: product, method: 'remove' }))
      }
    } else {
      cartContext?.updateCart({ item: product, method: 'remove' })
    }
  }, [cartContext, product, removeFromCart, session])

  const handleUpdateQty = useCallback(
    async (qty: number) => {
      if (session) {
        // updateCart().mutate({addressId:product.addressId,price:product.price,discountedprice:product.discountPerc,productId:product.productId,productname:product.name,userCustomizationData:product.userCustomizationData,})   .then(() => {
        //   cartContext?.updateCart({ item: product, method: 'quantity', qty: qty })
        // })
      } else {
        cartContext?.updateCart({ item: product, method: 'quantity', qty: qty })
      }
    },
    [cartContext, product, session]
  )

  const customizations = useMemo(() => {
    return product.userCustomizationData as CustomizationProps
  }, [product.userCustomizationData])

  const urlParams = useMemo(() => {
    const custom = product.userCustomizationData as CustomizationProps
    const dropdowns = custom.dropDowns
      ? custom.dropDowns.map((dropDown) => `${dropDown.title}=${dropDown.choice.choice}`).join('&')
      : ''
    const stepper = custom.stepper ? `${custom.stepper.title}=${custom.stepper.count}` : ''
    const text = custom.textInput
      ? custom.textInput.map((ele) => `${ele.title}=${ele.content}`)
      : ''
    return dropdowns + stepper + text
  }, [product.userCustomizationData])
  return (
    <div className=" flex flex-col gap-2 md:p-3 md:py-4 p-2">
      <div className=" flex gap-4">
        <div className=" rounded-sm overflow-hidden w-1/3">
          <Link href={`/product/${product.productId}?${urlParams}`}>
            <Image src={GetImageUrl(product.imageIds[0])} alt="image" width={200} height={200} />
          </Link>
        </div>
        <div className=" flex flex-col justify-between gap-3 w-2/3">
          <div className=" flex flex-col">
            <div className=" md:heading_small label_medium flex justify-between">
              <Link href={`/product/${product.productId}?${urlParams}`}>{product.name}</Link>
              <X
                className=" text-gray-3numbernumber cursor-pointer"
                onClick={handleRemoveFromCart}
              />
            </div>
            <div className=" flex gap-1 items-center">
              <div className=" heading_small">₹{product.price}</div>
              <div className=" label_medium text-gray-4numbernumber line-through">
                ₹{Math.round(product.price * (1 + product.discountPerc / 100))}
              </div>
              <div className=" label_medium text-primary-5numbernumber">
                ({product.discountPerc}% OFF)
              </div>
            </div>
          </div>
          <div>
            <DropdownMenu>
              <div className=" flex items-center mobile_semicondensed_small">
                Quantity:
                <DropdownMenuTrigger className=" border mobile_semicondensed_small rounded-sm pl-2 py-1 ml-1 flex gap-2 items-center">
                  {product.quantity} <ChevronDown width={15} height={15} />
                </DropdownMenuTrigger>
              </div>
              <DropdownMenuContent>
                {Array(10)
                  .fill('_')
                  .map((e, ind) => (
                    <DropdownMenuItem onClick={() => onQtyUpdate(ind + 1)}>
                      {ind + 1}
                    </DropdownMenuItem>
                  ))}
              </DropdownMenuContent>
            </DropdownMenu>
            <ProductExtraInfo className=" hidden md:flex" customizations={customizations} />
          </div>
        </div>
      </div>
      <ProductExtraInfo className=" flex md:hidden" customizations={customizations} />
    </div>
  )
}

export default CartProductCards
